import { view, anodum } from '@yola/ws-sdk';
import createCompositeItem from './create-composite-item';
import calculateNewItemPosition from './calculate-new-item-position';
import calculateCreationSequence from './calculate-creation-sequence';
import selectors from '../../../common/constants/selectors';

function addCompositeItem({ elementId }) {
  const liveNode = view.accessors.getLiveElement(elementId);
  let targetLiveNode = liveNode;

  if (anodum.isTag(liveNode, selectors.COMPOSITE_ITEM)) {
    targetLiveNode = liveNode.closest(selectors.COMPOSITE_GROUP);
  }

  const targetElementId = view.accessors.getLiveElementId(targetLiveNode);
  const compositionGroup = view.accessors.getStaticElement(targetElementId);
  const newCompositionItem = createCompositeItem({
    position: calculateNewItemPosition(compositionGroup),
    dataCreationSequence: calculateCreationSequence(compositionGroup),
  });

  compositionGroup.appendChild(newCompositionItem);

  view.operations.replaceElement(compositionGroup, targetElementId);
}

export default addCompositeItem;
